import React, { useState } from "react";

import axios from "axios";
import UserFeedBackHeader from "./UserFeedbackHeader";

const UserFeedback = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const formattedTime = currentDate.toLocaleTimeString();

    const payload = {
      ...formData,
      currentDate: formattedDate,
      currentTime: formattedTime,
    };

    try {
      await axios.post(
        "https://api.dremerz.net/api/DZ_8921_smcproject_feedbacktable_feedbacklist",
        payload
      );
      alert("Feedback submitted successfully!");
      setFormData({ name: "", mobile: "", description: "" });
    } catch (err) {
      alert("Error submitting feedback");
    }
  };

  return (
    <>
      <UserFeedBackHeader />
      <div className="container mt-5">
        <div className="row align-items-center">
          <div className="col-md-6 col-12 mb-4">
            <img
              src="https://static.vecteezy.com/system/resources/previews/018/977/782/non_2x/we-want-your-feedback-customer-feedbacks-survey-opinion-service-free-vector.jpg"
              alt="Feedback"
              className="img-fluid rounded"
            />
          </div>
          <div className="col-md-6 col-12">
            <h3 style={{ color: "#04143b" }}>
              Your Feedback Shapes Our Future
            </h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Mobile</label>
                <input
                  type="tel"
                  name="mobile"
                  className="form-control"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  rows="4"
                  value={formData.description}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn w-100"
                style={{
                  backgroundColor: "#04143B",
                  color: "#fff",
                  borderRadius: "20px",
                }}
              >
                Submit Feedback
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserFeedback;
